<template>
  <div class="mrgn-top">
   <v-flex class="space"></v-flex>
    <h2 class="center-aligned">What can you do with Cogneetiv?</h2>
    <h4 class="center-aligned">I am so glad you asked, so far this is what you can do.</h4>
       <v-flex class="space1"></v-flex>
    <template v-for="(item, index) in items">
      <v-list-item two-line :key="index">
        <v-list-item-content>
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "help",
  components: {},
  data() {
    return {
      items: [
        {
          title: "Greet",
          explanation: "Hi, how are you doing?",
        },
        {
          title: "Find/Search in google",
          explanation: "Google News about Tesla",
        },
        {
          title: "Starts an Inventory Form",
          explanation: "Create a Form",
        },
        {
          title: "Starts a New Quote",
          explanation: "Create a Quote",
        },
        {
          title: "Pull up the local weather",
          explanation: "What's the weather?",
        },
        {
          title: "Ask price of your phone",
          explanation: "What's the cost of an iPhone 11",
        },
        {
          title: "Ask assistant to book a meeting room",
          explanation: "book a meeting room at 5pm",
        },
        {
          title: "Ask time",
          explanation: " what time is it?",
        },
        {
          title: "Ask to show your Sales Reports, Emails, Tasks, Calendar",
          explanation: "Show my sales reports/emails/task/calendar",
        },

        {
          title: "Navigate to Screen by Voice command",
          explanation: "Navigate to Dashboard",
        },
      ],
    };
  },
};
</script>

<style scoped>
.space {
  height: 100px;
}
.space1 {
  height: 30px;
}
.mrgn-top {
  text-align: center;
}
.center-aligned {
  text-align: center;
  color: rgb(58, 57, 57);
}
h3 {
  color: #888;
}
</style>
